export const messages = {
  successfulUpload: "File uploaded successfully",
  fileAccepted: "File accepted",
  parseUploadFail:
    "An error occurred while parsing the file. Please try again or create manually.",
  noDataUploadFail: "File has missing data. Please try another file or create manually.",
  tooLongUploadFail:
    "File upload taking too long to process. Please try again or create manually.",
  uploadFail: "An error occurred while uploading. Please try again or create manually.",
  tooLargeUploadFail: "File is too large. Please upload a file smaller than 10 MB.",
  wrongTypeUploadFail: "Invalid file type. Please upload a .csv file.",
  fileRejectedFail: "File rejected. Please try again or create manually.",
  blankEntries:
    "Uploaded file contains blank entries. They will need to be deleted or updated on a future page.",
  fileSizeLimit:
    "Please upload a file smaller than 1 MB. Only data headers in the first row are needed.",
  delimiterMismatchWarning: (expectedType, uploadedType) =>
    `Schema delimiter expects ${expectedType}, but you uploaded ${uploadedType}. You can continue, but parsing or validation results may not match the schema as expected.`,
  linkmlMissingEnumsWarning: (enumNames) =>
    `This LinkML schema references enumeration types that are not included: ${enumNames.join(", ")}. Entry codes for the affected attributes will not be generated. Include the missing enum definitions from the parent schema.`
};
